export function getCategoryLabel(categoryName = '') {
  switch (categoryName.toLowerCase()) {
    case 'happiness': return 'Happiness Level';
    case 'time': return 'Time Alignment';
    case 'engagement': return 'Engagement Level';
    case 'capabilities': return 'Capability Level';
    case 'emotional': return 'Emotional Energy Level';
    default: return categoryName;
  }
}